module.exports = __webpack_public_path__ + "static/media/assetProEmailBanner.3cfe87e3.svg";